import { InputAdornment, TextField, Typography } from '@mui/material';

export function ClaimUserMembershipUserProfileInfoField(props: Readonly<{
    name: string,
    email: string
}>) {
    return (
        <TextField
            label="Tenant User Search"
            sx={{
                backgroundColor: 'background.paper',
                borderRadius: '4px',
            }}
            size="medium"
            InputProps={{
                style: {
                    height: '75px'
                },
                startAdornment: (
                    <InputAdornment position="start">
                        <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <Typography
                                marginTop='15px'
                                fontWeight='bold'
                            >
                                {props.name}
                            </Typography>
                            <Typography
                                variant="body1"
                                gutterBottom
                                color="grey"
                                noWrap
                                paddingBottom='5px'
                            >
                                {props.email}
                            </Typography>
                        </div>
                    </InputAdornment>
                )
            }}
            variant="filled"
            disabled
        />
    );
}
